(function($) {

	function handleVisibility() {

		var boxForward = $('.pagecategory-inner.active .more-item-box');
		var countForward = $('.pagecategory-inner.active [data-ct-box-count]');

		var boxBackward = $('.pagecategory-inner.active .more-item-back-box');
		var countBackward = $('.pagecategory-inner.active [data-ct-back-box-count]');

		if (parseInt(countForward.text()) === 0) {
			boxForward.addClass('hide');

		} else {
			boxForward.removeClass('hide');
		}

		if (parseInt(countBackward.text()) === 0) {
			boxBackward.addClass('hide');
		} else {
			boxBackward.removeClass('hide');
		}
	}

	function calculateCount() {

		var countElements = $('.pagecategory-inner.active .pagecategory-row').children('.column').length;

		var boxForward = $('.pagecategory-inner.active .more-item-box');
		var countForward = $('.pagecategory-inner.active [data-ct-box-count]');

		var boxBackward = $('.pagecategory-inner.active .more-item-back-box');
		var countBackward = $('.pagecategory-inner.active [data-ct-back-box-count]');
		var offset = $(window).width() < 1280 ? 4 : 5;

		if (countElements - offset > 0) {
			countForward.text(parseInt(countElements - offset));
			countBackward.text(0);
		} else {
			countForward.text(0);
			countBackward.text(0);
		}
	}

	function setForwardCount(number) {
		var countForward = $('.pagecategory-inner.active [data-ct-box-count]');
		countForward.text(parseInt(number));
	}

	function setBackwardCount(number) {
		var countBackward = $('.pagecategory-inner.active [data-ct-back-box-count]');
		countBackward.text(parseInt(number));
	}

	function ctSlideForward() {
		var elementToSlide = $('.pagecategory-inner.active .pagecategory-row .column:first-child');

		var marginNow = parseInt(elementToSlide.css('margin-left'));
		var marginAfter = marginNow - parseInt(elementToSlide.css('width'));

		var forwardCountNow = $('.pagecategory-inner.active [data-ct-box-count]').text();
		var backwardCountNow = $('.pagecategory-inner.active [data-ct-back-box-count]').text();

		elementToSlide.css('margin-left', marginAfter);		

		setForwardCount(parseInt(forwardCountNow) - 1);
		setBackwardCount(parseInt(backwardCountNow) + 1);
		
		handleVisibility();
		
	}

	function ctSlideBackward() {
		var elementToSlide = $('.pagecategory-inner.active .pagecategory-row .column:first-child');

		var marginNow = parseInt(elementToSlide.css('margin-left'));
		var marginAfter = marginNow + parseInt(elementToSlide.css('width'));

		var forwardCountNow = $('.pagecategory-inner.active [data-ct-box-count]').text();
		var backwardCountNow = $('.pagecategory-inner.active [data-ct-back-box-count]').text();

		elementToSlide.css('margin-left', marginAfter);

		setForwardCount(parseInt(forwardCountNow) + 1);
		setBackwardCount(parseInt(backwardCountNow) - 1);

		handleVisibility();
	}

	$(document).ready( function() {

		calculateCount();
		handleVisibility();

		// hoverhandling
		$('.card.pagecategory').on('mouseover click touchend touchstart', function() {
			// reset slides
			$('.card.pagecategory, .pagecategory-inner').each( function() {
				$(this).removeClass('active');
				$(this).find('.column:first-child').css('margin-left', '0');
			});

			// set .active class on selected element
			$(this).addClass('active');

			// get term id for showing the right page-slider
			var termId = $(this).find('.card-link').data('page-category');

			// set .active class on page-slider
			$('[data-page-category-parent=' + termId + ']').addClass('active');

			calculateCount();
			handleVisibility();
		});

		$(window).on('resize', function() {
			calculateCount();
		});

		$(document).on('click', '.pagecategory-inner.active [data-more-item]', function() {
			if ($(this).find('[data-ct-box-count]').text() > 0) {
				ctSlideForward();
			}
		});
		
		$(document).on('click', '.pagecategory-inner.active [data-more-item-back]', function() {
			if ($(this).find('[data-ct-back-box-count]').text() > 0) {
				ctSlideBackward();
			}
		});
	});
})(jQuery);